import React, { FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'

import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
  type: 'S' | 'M' | 'XL'
}

export const World: FC<IProps> = ({ type }) => {
  return (
    <div className={cn({
      [styles.wordImageContainer]: true,
      [styles.wordImageContainerXL]: type === 'XL',
      [styles.wordImageContainerM]: type === 'M',
      [styles.wordImageContainerS]: type === 'S'
    })}
         style={{
           // @ts-ignore
           '--SWorldBG': `url(${staticMultimedia.SWorldBG})`,
           '--MWorldBG': `url(${staticMultimedia.MWorldBG})`,
           '--XLWorldBG': `url(${staticMultimedia.XLWorldBG})`,
         }}
    >
      <div className={styles.wordSizeTitle}>{type}</div>
      <div className={styles.scrollingImage}></div>
    </div>
  )
}
